import { Capacitor } from '@capacitor/core';
import { version } from '../../package.json';

const platform = () => {
    if(window.process?.versions?.electron || navigator.userAgent.includes('Electron')) return 'electron';

    return Capacitor.getPlatform();
}

// Identifikator klijenta koji se šalje na svaki zahtjev kako bi se u logovima razlikovali izvori prometa.
export const clientId = `pgacc-${platform()}/${version}`;

// Dodaj identifikator klijenta u URL koji se otvara izravno u pregledniku (npr. preuzimanje datoteka).
export const withClient = (url) => `${url}${url.includes('?') ? '&' : '?'}client=${encodeURIComponent(clientId)}`;
